var render = function render(){var _vm=this,_c=_vm._self._c;return _c('a-card',{attrs:{"bordered":false}},[_c(_vm.currentComponet,{tag:"component",attrs:{"record":_vm.record},on:{"onEdit":_vm.handleEdit,"onGoBack":_vm.handleGoBack,"onCreate":_vm.handleCreate}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }